export default "__VITE_ASSET__5a3ded2d__"